<template>
  <div class="u-top">
    <div class="m-user">
      <div class="fl">今天是： {{ nowDate }}</div>
      <div class="fr">
        <div class="m-search">
          <input
            v-model="title"
            class="search-input"
            type="text"
            placeholder="输入关键字"
            @keyup.enter="searchNewsHandle">
          <span class="search-icon" @click="searchNewsHandle" />
        </div>
        <span
          class="top-center-official"
          @click="jump">
          中心官网首页
        </span>
        <div class="sign-in">
          <a href="javascript: void(0)" @click="toLogin">
            <span class="top-sign">{{ topSign }}</span>
          </a>
          <div v-if="topSign !== '登录'" class="sign-out">
            <div class="sign-out-box" @click="signOut">
              <span class="point" />
              <p>退出登录</p>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="banner-box">
      <img class="m-image" src="../../assets/images/home_party_100_logo2.png" alt="">
    </div>
    <div class="m-navs">
      <ul>
        <li><router-link
          :class="{active: pageName === 'Home'}"
          :to="{ name: 'Home' }">
          首页
        </router-link></li>
        <li><router-link
          :class="{active: pageName === 'FocusNews'}"
          :to="{ name: 'FocusNews' }">
          时政要闻
        </router-link></li>
        <li><router-link
          :class="{active: pageName === 'WorkTrends'}"
          :to="{ name: 'WorkTrends' }">
          工作动态
        </router-link></li>
        <li><router-link
          :class="{active: pageName === 'PartySpirit'}"
          :to="{ name: 'PartySpirit' }">
          支部动态
        </router-link></li>
        <li><router-link
          :class="{active: pageName === 'GroupMembers'}"
          :to="{ name: 'GroupMembers' }">
          群团工作
        </router-link></li>
        <li><router-link
          :class="{active: pageName === 'PartyRules'}"
          :to="{ name: 'PartyRules' }">
          党内法规
        </router-link></li>
        <li><router-link
          :class="{active: pageName === 'PartyPresence'}"
          :to="{ name: 'PartyPresence' }">
          党员风采
        </router-link></li>
        <li><router-link
          :class="{active: pageName === 'ContatcUs'}"
          :to="{ name: 'ContatcUs' }">
          联系我们
        </router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/apis/user'
import Cookies from 'js-cookie'
import { mapMutations } from 'vuex'

export default {
  name: 'Top',
  data() {
    return {
      topSign: '登录',
      nowDate: '',
      pageName: '',
      title: ''
    }
  },
  watch: {
    $route(to) {
      this.pageName = to.name
    }
  },
  mounted() {
    this.pageName = this.$route.name
    const date = new Date()
    const years = date.getFullYear()
    const month = (date.getMonth() + 1).toString()
    const days = date.getDate().toString()
    const week = date.getDay()
    const nowDay = ['', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'][week]
    this.nowDate = `${years}-${month.padStart(2, 0)}-${days.padStart(2, 0)}  ${nowDay}`
    this.initName()
  },
  methods: {
    ...mapMutations({
      SET_NEWS_NAME: 'news/SET_NEWS_NAME'
    }),
    async initName() {
      const userToken = Cookies.get('Miit-Token')
      if (userToken) {
        try {
          const params = {
            params: {
              xToken: userToken
            }
          }

          const data = await getUserInfo(params)
          this.topSign = data.data.userName
        } catch {
          Cookies.remove('Miit-Token')
        }
      }
    },
    searchNewsHandle() {
      this.SET_NEWS_NAME(this.title)
      if (this.$route.name !== 'SearchNews') {
        this.$router.push({ name: 'SearchNews' })
      }
    },
    jump() {
      window.open('/home/index')
    },
    toLogin() {
      if (this.topSign === '登录') {
        const { href } = window.location
        window.open(`/users/login?redirect=${href}`)
      }
    },
    signOut() {
      this.topSign = '登录'
      Cookies.remove('Miit-Token')
    }
  }
}
</script>

<style lang="scss" scoped>
.u-top{
  width: 100%;
  background-color: rgb(244, 244, 244);
  .m-user{
    width:1200px;
    height: 50px;
    margin: 0 auto;
    line-height: 50px;
    .m-search{
      position: relative;
      display: inline-block;
      margin-right: 32px;
      .search-input {
        position: relative;
        width: 160px;
        height: 26px;
        font-size: 12px;
        line-height: 24px;
        padding: 0 32px 0 12px;
        /*background: none;*/
        color: #999;
        border: solid 1px #ccc;
        border-radius: 12px;
      }
      .search-icon{
        position: absolute;
        right: 12px;
        top: 13px;
        width: 20px;
        height: 24px;
        background: url('../../assets/images/search_icon.png') no-repeat center center;
      }
    }
    .sign-in{
      position: relative;
      display: inline-block;
      &:hover .sign-out{
        display: block;
      }
      .sign-out{
        position: absolute;
        top: 36px;
        left:-20px;
        width: 120px;
        height: 100px;
        padding-top: 8px;
        display: none;
        z-index: 999999;
        .sign-out-box{
          background-color: #fff;
          border:solid 1px #ccc;
          padding: 10px 0;
          .point{
            position: absolute;
            z-index: 100;
            background-color: #fff;
            top:3px;
            left: 55px;
            width:10px;
            height: 10px;
            border-left: 1px solid #ccc;
            border-top: 1px solid #ccc;
            transform:rotate(45deg);
          }
          p{
            height: 35px;
            line-height: 35px;
            font-size:16px;
            text-align: center;
            cursor: pointer;
            width: 118px;
            display: block;
            &:hover{
              background-color: #0166cc;
              color: #fff;
            }
          }
        }
      }
    }
    .top-center-official{
      display: inline-block;
      padding-left: 30px;
      padding-right: 15px;
      height: 26px;
      line-height: 26px;
      color: #AA2124;
      margin-right: 15px;
      border-right: solid 1px #AA2124;
      background: url('../../assets/images/top_icon_1.png') no-repeat left center;
      cursor: pointer;
    }
    .top-sign{
      display: inline-block;
      padding-left: 30px;
      height: 26px;
      line-height: 26px;
      background: url('../../assets/images/top_icon_2.png') no-repeat left center;
      cursor: pointer;;
    }
  }
  .banner-box{
    position: relative;
    .banner-title{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-family: 'HYi4gj';
      font-size: 72px;
      color: #f4f4f4;
    }
  }
  .m-image{
    display: block;
    min-width: 1200px;
    height: 300px;
    width: auto;
    margin: 0 auto;
    border-top: solid 2px #ccc;
  }
  .m-navs{
    width: 100%;
    height: 40px;
    background: #9b181e;
    min-width: 1200px;
    font-size: 20px;
    ul{
      width: 1200px;
      margin: 0 auto;
      line-height: 40px;
      li{
        float: left;
        a{
          float: left;
          display: inline-block;
          color: #fff;
          padding: 0px 37px;
          &:hover {
            color: #f8bc6d;
            font-weight: bold;
          }
        }
      }
      .party-guide{
        position: relative;
        &:hover .party-spirit{
          display: block;
        }
        .party-spirit{
          display: none;
          position:absolute;
          top:40px;
          left:0;
          width:124px;
          height: 70px;
          background-color: #9b181e;
          .hover-a{
            width: 100%;
            text-align: center;
            color: #f8bc6d;
            font-size: 16px;
            line-height: 30px;
            margin-bottom: 5px;
            font-weight: 400;
            &:hover{
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
  .active{
    font-weight: 600;
    color: #f8bc6d !important;
  }
input::input-placeholder{
  line-height: 16px;
  color: #999;
  font-size: 12px;
}

::-webkit-input-placeholder { /* WebKit browsers */
  color: #999;
  font-size: 12px;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color: #999;
  font-size: 12px;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #999;
  font-size: 12px;
}
:-ms-input-placeholder { /* Internet Explorer 10+ */
  color: #999;
  font-size: 12px;
}
</style>
